import { useTranslation } from "react-i18next";
import { Image as ImageIcon, Tag as TagIcon, Plus, User } from "@phosphor-icons/react";

export function MobileBottomNav({ activeTab, onTabChange, onUploadClick }) {
  const { t } = useTranslation();
  const tabs = [
    { id: "all", label: t("mobile.untagged"), icon: ImageIcon },
    { id: "tags", label: t("mobile.tabTags"), icon: TagIcon },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-card border-t border-border flex items-center h-16 px-2" data-testid="mobile-bottom-nav">
      {tabs.map((t) => (
        <button
          key={t.id}
          data-testid={`mobile-nav-${t.id}`}
          onClick={() => onTabChange(t.id)}
          className={`flex flex-col items-center gap-1 text-[10px] font-mono-tag flex-1 h-full justify-center transition-colors ${activeTab === t.id ? "text-primary" : "text-muted-foreground"}`}
        >
          <t.icon size={22} weight={activeTab === t.id ? "fill" : "regular"} />
          {t.label}
        </button>
      ))}
      <button
        data-testid="mobile-nav-upload"
        onClick={onUploadClick}
        className="flex items-center justify-center -mt-6 h-14 w-14 rounded-full bg-primary text-primary-foreground shadow-lg border-4 border-background shrink-0"
      >
        <Plus size={26} weight="bold" />
      </button>
      <button
        data-testid="mobile-nav-me"
        onClick={() => onTabChange("me")}
        className={`flex flex-col items-center gap-1 text-[10px] font-mono-tag flex-1 h-full justify-center transition-colors ${activeTab === "me" ? "text-primary" : "text-muted-foreground"}`}
      >
        <User size={22} weight={activeTab === "me" ? "fill" : "regular"} />
        {t("mobile.me")}
      </button>
    </nav>
  );
}
